var map = {
	"./activedirectory.svg": 3407,
	"./adfs.svg": 3408,
	"./azuread.svg": 3409,
	"./custom.svg": 2440,
	"./email.svg": 1795,
	"./freeipa.svg": 3410,
	"./github.svg": 3411,
	"./googleoauth.svg": 3412,
	"./grafana.svg": 2661,
	"./jaeger.svg": 2662,
	"./keycloak.svg": 3413,
	"./kiali.svg": 2663,
	"./linux.svg": 3414,
	"./longhorn.svg": 2664,
	"./okta.svg": 3415,
	"./openldap.svg": 3416,
	"./pagerduty.svg": 2438,
	"./ping.svg": 3417,
	"./prometheus.svg": 2665,
	"./shibboleth.svg": 3418,
	"./slack.svg": 2437,
	"./webhook.svg": 2439,
	"./windows.svg": 3419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2503;